import { emptyObject } from '@constants/empty';
import Faqs from '@unicons-comp/Faqs/Faqs';
import { CARD_TYPES } from '@constants/unacademyIcons/anyfeed.constants';
import React from 'react';
import { AnyfeedDataProps } from 'types/unacademyIcons/anyfeed.type';

const AnyfeedKeyValue: React.FC<AnyfeedDataProps> = ({ data, list }) => {
  const { cardType } = data || emptyObject;

  if (cardType === CARD_TYPES.HERO) {
    return <Faqs faqs={list?.[0]?.items || []} />;
  }
};

AnyfeedKeyValue.displayName = 'AnyfeedKeyValue';

export default AnyfeedKeyValue;
